import React from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { PropertyCard } from "./PropertyCard";
import { trackButtonClick, trackCarouselInteraction } from "../utils/analytics";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export const HowItWorks = (props) => {
  const { t } = useTranslation();

  const handleSignupClick = () => {
    trackButtonClick('subscribe', 'how-it-works-section');
  };

  const steps = [
    {
      icon: "fa fa-search",
      key: "step1"
    },
    {
      icon: "fa fa-database",
      key: "step2"
    },
    {
      icon: "fa fa-bell",
      key: "step3"
    }
  ];

  // Get properties from translations
  const properties = t('properties', { returnObjects: true });

  return (
    <div id="how-it-works" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{t('howItWorks.title')}</h2>
        </div>
        <div className="row">
          {steps.map((step, i) => (
            <div key={`${step.key}-${i}`} className="col-md-4">
              {" "}
              <i className={step.icon}></i>
              <div className="service-desc">
                <h3>{t(`howItWorks.${step.key}.title`)}</h3>
                <p>{t(`howItWorks.${step.key}.text`)}</p>
              </div>
            </div>
          ))}
        </div>
        
        {/* Property Carousel */}
        <div className="row" style={{ marginTop: '60px' }}>
          <div className="col-md-10 col-md-offset-1">
            <h3 style={{ marginBottom: '30px', color: '#333', fontWeight: '600' }}>
              {t('howItWorks.examplesTitle')}
            </h3>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              onSlideChange={(swiper) => trackCarouselInteraction('slide_change', swiper.activeIndex)}
              onNavigationNext={() => trackCarouselInteraction('next', -1)}
              onNavigationPrev={() => trackCarouselInteraction('prev', -1)}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                }
              }}
            >
              {properties.map((property, index) => (
                <SwiperSlide key={index}>
                  <PropertyCard property={property} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        
        <div className="row" style={{ marginTop: '60px' }}>
          <div className="col-md-8 col-md-offset-2">
            <div className="how-it-works-notice">
              <div className="notice-content">
                <div className="notice-icon">
                  <i className="fa fa-info-circle"></i>
                </div>
                <p className="notice-text-main">
                  {t('howItWorks.currentOffer')}
                </p>
              </div>
              <div className="notice-footer">
                <i className="fa fa-rocket" style={{ marginRight: '10px' }}></i>
                <span>{t('howItWorks.futurePlans')}</span>
              </div>
              <div style={{ marginTop: '20px', textAlign: 'center' }}>
                <a
                  href="#signup"
                  className="btn btn-custom btn-md page-scroll"
                  onClick={handleSignupClick}
                >
                  {t('nav.signup')} <i className="fa fa-arrow-down" style={{ marginLeft: '8px' }}></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

